module.exports = __webpack_public_path__ + "img/2.716775b5.jpg";